import { render, staticRenderFns } from "./new-custom-switcher.vue?vue&type=template&id=1f56abdf&scoped=true&"
import script from "./new-custom-switcher.vue?vue&type=script&lang=ts&"
export * from "./new-custom-switcher.vue?vue&type=script&lang=ts&"
import style0 from "./new-custom-switcher.vue?vue&type=style&index=0&id=1f56abdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56abdf",
  null
  
)

export default component.exports